import { apiCall } from '../../utils/restclient'
import { LOGIN, LOGIN_ERROR, LOGIN_SUCCESS } from './HomeConstants'
import env from '../../env.json'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function login(loginObj) {
  const endpoint = 'api/v1/auth/login'
  const action = {
    type: LOGIN,
    payload: { endpoint, body: { ...loginObj } },
  }
  const telemetryConfig = {
    publicToken: env.stytchToken,
    submitURL: 'auth-dfp.quick.md',
  }

  // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
  window.GetTelemetryID(telemetryConfig).then((telemetryId) => {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'POST', null, JSON.stringify({ ...action.payload.body, TelemetryId: telemetryId }), {
      success: LOGIN_SUCCESS,
      error: LOGIN_ERROR,
    })
  })
  return action
}
